import axios from 'axios';
import {IGeofenceRoute} from 'app/shared/model/geofence-route.model';

/**
 * Geofence Route Service
 * Contains synchronous API calls for geofence route functionality
 */
class GeofenceRouteService {
  private searchUrl = 'api/search/geofence-routes';

  /**
   * Search geofence routes by start and end council IDs
   */
  async searchEntities(startId?: string, endId?: string, page?: number, size?: number, sort?: string): Promise<IGeofenceRoute[]> {
    const params = {
      ...startId ? { startId } : {},
      ...endId ? { endId } : {},
      ...page !== undefined ? { page } : {},
      ...size ? { size } : {},
      ...sort ? { sort } : {}
    };
    
    const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    const requestUrl = `${this.searchUrl}?${queryString}`;
    
    const response = await axios.get<IGeofenceRoute[]>(requestUrl);
    return response.data;
  }
}

// Export singleton instance
export const geofenceRouteService = new GeofenceRouteService();
export default geofenceRouteService;
